import { styled } from '../../../styles';
import Box from '../../../Box';
export const StyledNavigationRootContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    minWidth: theme.palette.navigation.container.primary.width,
    flexBasis: theme.palette.navigation.container.primary.width,
    background: theme.palette.navigation.container.primary.background.default,
    borderRight: `${theme.palette.navigation.container.primary.border.width} solid ${theme.palette.navigation.container.primary.border.default}`
}));
export const StyledNavigationLogoContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: theme.palette.space.container.spacious,
    paddingBottom: theme.palette.space.container.default,
    gap: theme.palette.navigation.container.primary.spaceBetween
}));
export const StyledProductContainer = styled(Box)(({ theme }) => ({
    gap: theme.palette.space.container.dense,
    display: 'flex',
    flexDirection: 'column',
    alignContent: 'center'
}));
export const StyledGlobalContainer = styled(Box)(({ theme }) => ({
    gap: theme.palette.navigation.container.primary.spaceBetween,
    marginTop: 'auto',
    alignContent: 'center',
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: theme.palette.space.container.dense
}));
export const StyledTopContainer = styled(Box)(({ theme }) => ({
    gap: theme.palette.navigation.container.primary.spaceBetween,
    alignContent: 'center',
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: theme.palette.space.container.default
}));
export const NavigationSubMenu = styled(Box, {
    shouldForwardProp: prop => prop !== 'open'
})(({ theme, open }) => ({
    background: open ? theme.palette.navigation.container.secondary.background.default : 'transparent',
    borderRightColor: theme.palette.navigation.container.secondary.border.default,
    borderRightStyle: 'solid',
    borderRightWidth: open ? theme.palette.navigation.container.secondary.border.width : 0,
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    marginRight: open ? -parseFloat(theme.palette.navigation.container.secondary.width) : 0,
    overflowX: 'hidden',
    overflowY: 'auto',
    transition: 'width 0.25s, margin-right 0.25s',
    width: open ? theme.palette.navigation.container.secondary.width : 0,
    zIndex: 2
}));
export const ClickCapture = styled(Box)({
    position: 'absolute',
    top: 0,
    left: 342,
    width: 'calc(100% - 342px)',
    height: '100%',
    opacity: 0
});
//# sourceMappingURL=NavigationBar.styles.js.map